export default "__VITE_ASSET__d3bc2b99__"